import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Compass } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/5577693/pexels-photo-5577693.jpeg";

export default function Hero({ onPlanTrip, onExplore }) {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative h-[100svh] min-h-[640px] w-full overflow-hidden grain-overlay"
    >
      {/* Background image with slow zoom */}
      <div className="absolute inset-0 animate-slow-zoom">
        <img
          src={HERO_IMG}
          alt="Luxury overwater villa at sunset"
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>

      {/* Dark luxury gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/30 to-[#0A2342]/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="overline text-white/90">A bespoke travel atelier</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display text-white text-5xl sm:text-6xl lg:text-7xl xl:text-[4.5rem] leading-[0.95] tracking-tight"
          >
            Luxury Travel,
            <br />
            <span className="text-[#C9A227]">Extraordinary Journeys.</span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-8 text-white/85 text-base sm:text-lg lg:text-xl max-w-2xl leading-relaxed font-light"
          >
            Custom international holidays · Visa experts · Premium experiences
            across <span className="text-white font-medium">25+ countries</span> — designed by humans who travel for a living.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button data-testid="hero-plan-cta" onClick={onPlanTrip} className="btn-gold">
              Plan My Trip
              <ArrowRight className="w-4 h-4" />
            </button>
            <button data-testid="hero-explore-cta" onClick={onExplore} className="btn-ghost">
              <Compass className="w-4 h-4" />
              Explore Packages
            </button>
          </div>
        </motion.div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-4 right-6 hidden lg:flex flex-col items-center gap-2 text-white/60 text-[10px] tracking-[0.3em] uppercase">
        <span>Scroll</span>
        <span className="w-px h-10 bg-white/40" />
      </div>
    </section>
  );
}
